import React from 'react';
import './FollowUs.scss';

const FollowUs = props => {
  const {
    section,
    loginStatus,
    /* dataLocale, */ redisCommonData: { SOCIAL_LOGIN },
    followData,
  } = props;
  const socialLoginArray = followData?.map((fd, idx) => (
    <a
      key={idx}
      href={fd?.redirectUrl}
      rel="noopener noreferrer"
      target={fd?.isNewTab ? '_blank' : '_self'}
      onClick={() => {
        if (window.dtm.LenskartRewamp)
          window.dtm.LenskartRewamp.footer.click.followus(section, fd?.name, loginStatus);
      }}
    >
      <i
        aria-hidden="true"
        className={fd?.class ? fd.class + ' text-color-white' : 'text-color-white'}
      ></i>
    </a>
  ));
  return <div className="socialLK_followIcons">{socialLoginArray}</div>;
};

export default FollowUs;
